import { Vector3 } from 'three';
import { SceneData } from '../../../atoms/scene';


const scenes_scenario_80: { [key: string]: SceneData } = {
	'scene_01': {
		camera_settings: {
			position: new Vector3(-1.9, 1.5, 3),
			target: new Vector3(-1.5, 1.5, 1)

		},

		objects: {
			'13': {
				type: 'character',
				position: new Vector3(-1.6, 0, 1.5),
				rotation: [0, -0.2, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},

			'4': {
				type: 'character',
				position: new Vector3(-2, -5, 1.5),
				rotation: [0, 0.1, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},
			'12': {
				type: 'character',
				position: new Vector3(2, -0.45, -1.6),
				rotation: [0, 0.1, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
		},
	},

	'spirith_s1_jansen_lounge': {
		camera_settings: {
			position: new Vector3(-1.9, 1.5, 3),
			target: new Vector3(-1.5, 1.5, 1)
		},

		objects: {
			'13': {
				type: 'character',
				position: new Vector3(0.1, -0.42, -1.6),
				rotation: [0, -0.2, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
			'12': {
				type: 'character',
				position: new Vector3(2, -0.45, -1.6),
				rotation: [0, 0.1, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
		},

	},

	'spirith_s1_jansen_carlos': {
		camera_settings: {
			position: new Vector3(-1.9, 1.5, 3),
			target: new Vector3(-1.8, 1.5, 1)
		},

		objects: {
			'4': {
				type: 'character',
				position: new Vector3(-2, 0, 1.5),
				rotation: [0, 0.1, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},

			'13': {
				type: 'character',
				position: new Vector3(-0.5, 0, 1.2),
				rotation: [0, -0.9, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},
			'12': {
				type: 'character',
				position: new Vector3(2, -0.45, -1.6),
				rotation: [0, 0.1, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
		},

	},

};

export default scenes_scenario_80;
